export default "__VITE_ASSET__CgzpvLGv__"